import { Injectable, Inject } from '@angular/core';
import { Router, Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Acuerdo } from './acuerdo.model';
import { BackendService } from '../core/backend.service';
import { OperationalParametric } from '../cliente/operationalParametric.model';
import { EstadoAcuerdo } from './estado-acuerdo.model';

@Injectable()
export class AcuerdoResolver implements Resolve<Acuerdo> {
  constructor(
    protected router: Router,
    protected backendService: BackendService,
  ) {}

  async resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    try {
      const id = route.params.id || 'agregar';

      if (id === 'agregar') {
        const acuerdo = this.backendService.new(Acuerdo);
        acuerdo.estado = new OperationalParametric();
        acuerdo.estado.id = EstadoAcuerdo.Activo;
        return acuerdo;
      }

      const data = await this.backendService.get(Acuerdo, Acuerdo.path + id).toPromise();

      // Si el path es replicar lo marco para que el componente limpie los datos y pueda crear en base al acuerdo uno nuevo
      if (route.routeConfig.path.indexOf('replicar') === 0) {
        data.numero = -1;
      }
      return data;
    } catch (error) {
      this.router.navigate(['/acuerdos']);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/acuerdo/acuerdo.resolver.ts